import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const threadSummaryPayloadSchema = z
    .object({
        type: z.literal('thread_summary').optional(),
        summary: z.string(),
        recorded_at: z.iso.datetime({ offset: true }),
        recorded_at_timezone: z.string().nullable().optional(),
    })
    .strip();

export const threadSummaryDefinitions = {
    thread_summary: defineInvisible('thread_summary', {
        disposition: 'invisible',
        schema: threadSummaryPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const threadSummaryContractFixtures = {
    valid: {
        type: 'thread_summary',
        summary: 'Internal thread summary',
        recorded_at: '2026-08-28T12:00:00Z',
        recorded_at_timezone: 'America/New_York',
    },
    malformed: {
        type: 'thread_summary',
        summary: 7,
        recorded_at: '2026-08-28T12:00:00Z',
    },
} as const;
